export default "<div mat-dialog-content class=\"wrapper-image\">\r\n    <img class=\"img\" [src]=\"data.img\" />\r\n</div>";